import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-bachelor-of-business-administration-degree',
  templateUrl: './bachelor-of-business-administration-degree.component.html',
  styleUrls: ['./bachelor-of-business-administration-degree.component.scss']
})
export class BachelorOfBusinessAdministrationDegreeComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
